// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"ff4a86e0","411":"7136715d","546":"ee4e3194","574":"2b12c4e9","628":"75f182a4","761":"e46f65eb"}[chunkId] + ".chunk.css";
};